/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Item_Col_LotInputs */

const vi_pl_item_col_lot = /** @type {(inputs: Pl_Item_Col_LotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô mua`)
};

/**

* @param {Pl_Item_Col_LotInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_item_col_lot = /** @type {((inputs?: Pl_Item_Col_LotInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Item_Col_LotInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_item_col_lot(inputs)
});